export const TECH_SIGNATURES = [
    // --- CMS ---
    {
        name: "WordPress",
        category: "CMS",
        patterns: [
            { regex: /content="WordPress/i, weight: 100 },
            { regex: /\/wp-content\//i, weight: 100 },
            { regex: /\/wp-includes\//i, weight: 100 },
            { regex: /class="[^"]*wp-block/i, weight: 50 },
        ],
    },
    {
        name: "Shopify",
        category: "E-commerce",
        isEcommerce: true,
        patterns: [
            { regex: /cdn\.shopify\.com/i, weight: 100 },
            { regex: /Shopify\.shop/i, weight: 100 },
            { regex: /shopify-section/i, weight: 80 },
        ],
    },
    {
        name: "Wix",
        category: "CMS",
        patterns: [
            { regex: /content="Wix\.com/i, weight: 100 },
            { regex: /wix-site/i, weight: 80 },
            { regex: /static\.wixstatic\.com/i, weight: 100 },
        ],
    },
    {
        name: "Squarespace",
        category: "CMS",
        patterns: [
            { regex: /static\.squarespace\.com/i, weight: 100 },
            { regex: /squarespace-audio-player/i, weight: 80 },
        ],
    },
    {
        name: "Webflow",
        category: "CMS",
        patterns: [
            { regex: /content="Webflow/i, weight: 100 },
            { regex: /w-nav/i, weight: 60 },
            { regex: /webflow\.css/i, weight: 90 },
        ],
    },
    {
        name: "Joomla",
        category: "CMS",
        patterns: [
            { regex: /content="Joomla!/i, weight: 100 },
            { regex: /\/media\/jui\//i, weight: 90 },
        ],
    },
    {
        name: "Drupal",
        category: "CMS",
        patterns: [
            { regex: /content="Drupal/i, weight: 100 },
            { regex: /Drupal\.settings/i, weight: 90 },
        ],
    },
    {
        name: "Ghost",
        category: "CMS",
        patterns: [
            { regex: /content="Ghost/i, weight: 100 },
            { regex: /ghost-sdk/i, weight: 80 },
        ],
    },
    {
        name: "Blogger",
        category: "CMS",
        patterns: [
            { regex: /content="blogger/i, weight: 100 },
            { regex: /blogspot\.com/i, weight: 80 },
        ],
    },

    // --- E-commerce ---
    {
        name: "Magento",
        category: "E-commerce",
        isEcommerce: true,
        patterns: [
            { regex: /static\/_requirejs/i, weight: 90 },
            { regex: /Mage\.Cookies/i, weight: 90 },
            { regex: /text\/x-magento-init/i, weight: 100 },
        ],
    },
    {
        name: "WooCommerce",
        category: "E-commerce",
        isEcommerce: true,
        patterns: [
            { regex: /woocommerce-active/i, weight: 100 },
            { regex: /woocommerce/i, weight: 80 },
            { regex: /wc-store-functions/i, weight: 90 },
        ],
    },
    {
        name: "BigCommerce",
        category: "E-commerce",
        isEcommerce: true,
        patterns: [
            { regex: /cdn11\.bigcommerce\.com/i, weight: 100 },
            { regex: /bigcommerce\.com\/analytics/i, weight: 90 },
        ],
    },
    {
        name: "PrestaShop",
        category: "E-commerce",
        isEcommerce: true,
        patterns: [
            { regex: /prestashop/i, weight: 80 },
            { regex: /var prestashop/i, weight: 100 },
        ],
    },
    {
        name: "OpenCart",
        category: "E-commerce",
        isEcommerce: true,
        patterns: [
            { regex: /route=common\/home/i, weight: 70 },
            { regex: /catalog\/view\/theme/i, weight: 60 },
        ],
    },

    // --- JavaScript Frameworks ---
    {
        name: "React",
        category: "Framework",
        patterns: [
            { regex: /react-dom/i, weight: 90 },
            { regex: /data-reactroot/i, weight: 100 },
            { regex: /_react\./i, weight: 70 },
        ],
    },
    {
        name: "Next.js",
        category: "Framework",
        patterns: [
            { regex: /id="__next"/i, weight: 100 },
            { regex: /_next\/static/i, weight: 100 },
            { regex: /__NEXT_DATA__/i, weight: 100 },
        ],
    },
    {
        name: "Vue.js",
        category: "Framework",
        patterns: [
            { regex: /data-v-/i, weight: 80 },
            { regex: /vue\.global\.js/i, weight: 90 },
            { regex: /__vue__/i, weight: 90 },
        ],
    },
    {
        name: "Nuxt.js",
        category: "Framework",
        patterns: [
            { regex: /_nuxt\//i, weight: 100 },
            { regex: /__NUXT__/i, weight: 100 },
        ],
    },
    {
        name: "Angular",
        category: "Framework",
        patterns: [
            { regex: /app-root/i, weight: 80 },
            { regex: /ng-version/i, weight: 100 },
            { regex: /angular-core/i, weight: 90 },
        ],
    },
    {
        name: "Svelte",
        category: "Framework",
        patterns: [
            { regex: /svelte-/i, weight: 80 },
            { regex: /__svelte/i, weight: 90 },
        ],
    },
    {
        name: "jQuery",
        category: "Library",
        patterns: [
            { regex: /jquery[.-]?[0-9.]*\.js/i, weight: 90 },
            { regex: /jquery\.min\.js/i, weight: 90 },
        ],
    },
    {
        name: "Alpine.js",
        category: "Framework",
        patterns: [
            { regex: /x-data=/i, weight: 100 },
            { regex: /alpine\.js/i, weight: 90 },
        ],
    },
    {
        name: "Backbone.js",
        category: "Framework",
        patterns: [
            { regex: /backbone\.js/i, weight: 90 },
            { regex: /backbone-min\.js/i, weight: 90 },
        ],
    },
    {
        name: "Lodash",
        category: "Library",
        patterns: [
            { regex: /lodash\.js/i, weight: 90 },
        ],
    },
    {
        name: "Moment.js",
        category: "Library",
        patterns: [
            { regex: /moment\.js/i, weight: 90 },
        ],
    },

    // --- UI Frameworks ---
    {
        name: "Tailwind CSS",
        category: "UI",
        patterns: [
            { regex: /cdn\.tailwindcss\.com/i, weight: 100 },
            { regex: /class="[^"]*text-\w+-\d+/i, weight: 40 },
            { regex: /--tw-/i, weight: 60 },
        ],
    },
    {
        name: "Bootstrap",
        category: "UI",
        patterns: [
            { regex: /bootstrap(?:\.min)?\.css/i, weight: 90 },
            { regex: /bootstrap(?:\.min)?\.js/i, weight: 90 },
        ],
    },
    {
        name: "Materialize CSS",
        category: "UI",
        patterns: [
            { regex: /materialize\.css/i, weight: 90 },
        ],
    },
    {
        name: "Bulma",
        category: "UI",
        patterns: [
            { regex: /bulma\.css/i, weight: 90 },
        ],
    },
    {
        name: "Foundation",
        category: "UI",
        patterns: [
            { regex: /foundation\.css/i, weight: 90 },
        ],
    },
    {
        name: "Ant Design",
        category: "UI",
        patterns: [
            { regex: /ant-btn/i, weight: 80 },
            { regex: /ant-layout/i, weight: 80 },
        ],
    },
    {
        name: "Chakra UI",
        category: "UI",
        patterns: [
            { regex: /chakra-ui/i, weight: 80 },
            { regex: /css-[0-9a-z]{4,}/i, weight: 30 }, // Generic hash class, low weight
        ],
    },
    {
        name: "Font Awesome",
        category: "Font",
        patterns: [
            { regex: /font-awesome/i, weight: 90 },
            { regex: /fa-[a-z]+/i, weight: 60 },
        ],
    },

    // --- Analytics & Marketing ---
    {
        name: "Google Analytics 4",
        category: "Analytics",
        patterns: [
            { regex: /G-[A-Z0-9]+/i, weight: 100 },
            { regex: /googletagmanager\.com\/gtag\/js/i, weight: 90 },
        ],
    },
    {
        name: "Google Tag Manager",
        category: "Analytics",
        patterns: [
            { regex: /googletagmanager\.com\/gtm\.js/i, weight: 100 },
            { regex: /GTM-[A-Z0-9]+/i, weight: 90 },
        ],
    },
    {
        name: "Facebook Pixel",
        category: "Advertising",
        patterns: [
            { regex: /fbevents\.js/i, weight: 100 },
            { regex: /fbq\(/i, weight: 90 },
        ],
    },
    {
        name: "HubSpot",
        category: "Marketing",
        patterns: [
            { regex: /js\.hs-scripts\.com/i, weight: 100 },
            { regex: /hs-form/i, weight: 80 },
        ],
    },
    {
        name: "Hotjar",
        category: "Analytics",
        patterns: [
            { regex: /static\.hotjar\.com/i, weight: 100 },
            { regex: /hjid/i, weight: 80 },
        ],
    },
    {
        name: "Klaviyo",
        category: "Marketing",
        patterns: [
            { regex: /static\.klaviyo\.com/i, weight: 100 },
        ],
    },
    {
        name: "Segment",
        category: "Analytics",
        patterns: [
            { regex: /cdn\.segment\.com\/analytics\.js/i, weight: 100 },
        ],
    },
    {
        name: "Mixpanel",
        category: "Analytics",
        patterns: [
            { regex: /cdn\.mxpnl\.com/i, weight: 100 },
        ],
    },
    {
        name: "Intercom",
        category: "Support",
        patterns: [
            { regex: /widget\.intercom\.io/i, weight: 100 },
        ],
    },

    // --- Infrastructure / Hosting / CDN ---
    {
        name: "Cloudflare",
        category: "CDN",
        patterns: [
            { regex: /cdnjs\.cloudflare\.com/i, weight: 80 },
            { regex: /cf-ray/i, weight: 100 },
        ],
    },
    {
        name: "Vercel",
        category: "Hosting",
        patterns: [
            { regex: /_vercel/i, weight: 90 },
        ],
    },
    {
        name: "Netlify",
        category: "Hosting",
        patterns: [
            { regex: /netlify/i, weight: 90 },
        ],
    },
    {
        name: "AWS CloudFront",
        category: "CDN",
        patterns: [
            { regex: /cloudfront\.net/i, weight: 90 },
        ],
    },
    {
        name: "Amazon S3",
        category: "Storage",
        patterns: [
            { regex: /s3\.amazonaws\.com/i, weight: 90 },
        ],
    },
    {
        name: "Heroku",
        category: "Hosting",
        patterns: [
            { regex: /herokuapp\.com/i, weight: 60 }, // Mostly in subdomains
        ],
    },

    // --- Payments ---
    {
        name: "Stripe",
        category: "Payments",
        isEcommerce: true,
        patterns: [
            { regex: /js\.stripe\.com/i, weight: 100 },
        ],
    },
    {
        name: "PayPal",
        category: "Payments",
        isEcommerce: true,
        patterns: [
            { regex: /paypal\.com\/sdk/i, weight: 100 },
            { regex: /paypal-objects/i, weight: 80 },
        ],
    },
    {
        name: "Square",
        category: "Payments",
        isEcommerce: true,
        patterns: [
            { regex: /js\.squareup\.com/i, weight: 100 },
        ],
    },
    {
        name: "Klarna",
        category: "Payments",
        isEcommerce: true,
        patterns: [
            { regex: /klarnapayments/i, weight: 90 },
        ],
    },

    // --- Server Technologies (Inferred) ---
    {
        name: "PHP",
        category: "Language",
        patterns: [
            { regex: /\.php/i, weight: 80 },
            { regex: /wp-content/i, weight: 50 }, // WordPress implies PHP
        ],
    },
    {
        name: "ASP.NET",
        category: "Framework",
        patterns: [
            { regex: /__VIEWSTATE/i, weight: 100 },
            { regex: /\.aspx/i, weight: 90 },
        ],
    },
    {
        name: "Laravel",
        category: "Framework",
        patterns: [
            { regex: /X-CSRF-TOKEN/i, weight: 70 }, // Common in Laravel
            { regex: /laravel_session/i, weight: 70 }, // If visible in cookies/headers (not visible in body usually, but maybe scripts)
        ],
    },
    // --- Video & Media ---
    {
        name: "YouTube",
        category: "Media",
        patterns: [
            { regex: /youtube\.com/i, weight: 100 },
            { regex: /yt-player/i, weight: 100 },
            { regex: /ytimg\.com/i, weight: 90 },
        ],
    },
    {
        name: "Vimeo",
        category: "Media",
        patterns: [
            { regex: /vimeo\.com/i, weight: 100 },
            { regex: /player\.vimeo\.com/i, weight: 100 },
        ],
    },
    {
        name: "Polymer",
        category: "Framework",
        patterns: [
            { regex: /polymer-/i, weight: 90 },
            { regex: /Polymer\(/i, weight: 100 },
        ],
    },
    {
        name: "Google Cloud",
        category: "Hosting",
        patterns: [
            { regex: /storage\.googleapis\.com/i, weight: 90 },
            { regex: /appspot\.com/i, weight: 90 },
        ],
    },
    {
        name: "Google Maps",
        category: "Map",
        patterns: [
            { regex: /maps\.googleapis\.com/i, weight: 100 },
            { regex: /maps\.google\.com/i, weight: 100 },
        ],
    },
    {
        name: "Google Fonts",
        category: "Font",
        patterns: [
            { regex: /fonts\.googleapis\.com/i, weight: 100 },
        ],
    },
    {
        name: "Google AdSense",
        category: "Advertising",
        patterns: [
            { regex: /googlesyndication\.com/i, weight: 100 },
            { regex: /adsbygoogle/i, weight: 100 },
        ],
    },
    {
        name: "DoubleClick",
        category: "Advertising",
        patterns: [
            { regex: /doubleclick\.net/i, weight: 100 },
            { regex: /googletagservices\.com/i, weight: 90 },
        ],
    },
];
